import React from 'react';
import { Box, Typography } from '@mui/material';
import VendedorVisualizar from '../components/vendedor/VendedorVisualizar';

const VendedorVisualizarPage: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Visualizar Vendedor
      </Typography>
      <VendedorVisualizar />
    </Box>
  );
};

export default VendedorVisualizarPage;
